import React, { useEffect, useState } from "react";

type BaseInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

interface AmountInputProps extends BaseInputProps {
  value: number;
  onChange: (value: number) => void;
}

const formatThousand = (val: number | string): string => {
  return val
    .toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const unformatThousand = (val: string): number => {
  return Number(val.replace(/\./g, "").replace(/\D/g, ""));
};

const AmountInput: React.FC<AmountInputProps> = ({ value, onChange, ...props }) => {
  const [display, setDisplay] = useState(formatThousand(value));

  useEffect(() => {
    setDisplay(formatThousand(value));
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const numeric = unformatThousand(raw);
    setDisplay(formatThousand(numeric));
    onChange(numeric); // langsung update state
  };

  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      value={display}
      onChange={handleChange}
    />
  );
};

export default AmountInput;
